import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sp-actions',
  templateUrl: './sp-actions.component.html',
  styleUrls: ['./sp-actions.component.css']
})
export class SpActionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
